import { render, staticRenderFns } from "./SpeciesManagement.vue?vue&type=template&id=144025a4&scoped=true"
import script from "./SpeciesManagement.vue?vue&type=script&lang=js"
export * from "./SpeciesManagement.vue?vue&type=script&lang=js"
import style0 from "./SpeciesManagement.vue?vue&type=style&index=0&id=144025a4&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "144025a4",
  null
  
)

export default component.exports